import { SharePointParentFolderItem } from 'shared'

/**
 * generates workaround messages for when a file upload fails
 *
 * @param folder the {@link SharePointParentFolderItem} associated with the upload
 */
export function getWorkarounds(folder: SharePointParentFolderItem) {
  if (!folder) return []
  return [
    `Luckily, there is a workaround for ${folder.module.name}.`,
    `Navigate to ${folder.name} in your SharePoint Document Library.`,
    `Create, or open, ${folder.description} and manually upload the file(s) there.`,
    'Please copy any following errors using the clipboard icon and report them to our support team.',
  ]
}
